module.exports = __webpack_public_path__ + "img/rationality-b.fcff15d4.svg";